import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-layout-authenticated',
  templateUrl: './layout-authenticated.component.html',
  styleUrls: ['./layout-authenticated.component.scss']
})

export class LayoutAuthenticatedComponent implements OnInit {
  mobile = false;
  scrollDistance: number;
  windowSize = { h: window.innerHeight, w: window.innerWidth };
  hideFooter = false;
  menuResize = false;
  enableMenuScroll = false;
  enableMobileIcon = false;
  rotaCurrent = '';

  hideFooterOnUrls = ['/lote/cadastrar', '/perfil/alterar-senha', '/perfil/alterar-email'];
  resizeMenu = ['/lote/cadastrar'];

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router) {
    this.checkRouterChange();
  }

  @HostListener('window:scroll', [])
  onScroll() {
    const { body, documentElement } = this.document;
    this.scrollDistance = window.pageYOffset || documentElement.scrollTop || body.scrollTop || 0;
    this.menuConfig();
  }

  @HostListener('window:resize', ['$event'])
  resizeWindow(event: WindowEventMap) {
    this.mobile = (window.innerWidth < 1024);
    this.windowSize = { h: window.innerHeight, w: window.innerWidth };
    this.menuConfig();
  }

  ngOnInit() {}

  checkRouterChange() {
    const { hideFooterOnUrls, resizeMenu } = this;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.menuResize = resizeMenu.some(val => (val === event.url));
        this.hideFooter = hideFooterOnUrls.some(val => (val === event.url));
        this.rotaCurrent = event.url;
        this.menuConfig();
      }
    });
  }

  menuConfig() {
    if (this.rotaCurrent === '/') {
      this.enableMenuScroll = this.scrollDistance > 70 || this.menuResize;
      this.enableMobileIcon = this.windowSize.w <= 1024 || this.scrollDistance > 70;
    } else {
      this.enableMenuScroll = true;
      this.enableMobileIcon = true;
    }
  }
}
